export const AVATAR_SIZE = 40;
export const NORMAL_SIZE_DRAWER = '86px';
export const SMALL_SIZE_DRAWER = '50px';
